<template>
  <q-dialog
    :name="uiMeta?.config?.rewardsName"
    pc="pc"
    :closeable="true"
    :close-button-props="uiMeta?.layout?.wrapper?.closeButtonWrapper">
    <q-section
      :bg-i="prizeList.length > 4 ? uiMeta?.images?.rewardsDialog2 : uiMeta?.images?.rewardsDialog1"
      :wh="`${prizeList.length > 4 ? uiMeta?.config?.dialogSize2 : uiMeta?.config?.dialogSize1}`"
      p="relative">
      <q-section wh="282 108" pc="x" pt="66" v-if="prizeList.length < 4" :class="genClass()">
        <q-section
          v-for="prize in prizeList"
          wh="90 134"
          p="relative"
          class="flex flex-col items-center"
          :style="{ transform: genScale() }">
          <q-section :bg-i="uiMeta?.images?.rewardsMask" :wh="`90`" bg-s="contain" bg-r="no-repeat" p="relative">
            <q-section v-if="prize.isSp" wh="100%" :bg-i="lightImg" class="bright"></q-section>
            <q-section :bg-i="prize.reward_icon" wh="80%" bg-s="contain" bg-r="no-repeat" bgP="center" pc="pc"></q-section>
          </q-section>
          <q-section wh="100% 33" fs="12" :fc="uiMeta?.config.nameColor" fw="400" p="relative" mt="3" class="text-center">
            {{ prize.reward_name }}
          </q-section>
        </q-section>
      </q-section>
      <q-section wh="268 292" pc="x" pt="62" v-if="prizeList.length >= 4" class="grid">
        <q-section v-for="prize in prizeList" wh="60 92" p="relative">
          <q-section :bg-i="uiMeta?.images?.rewardsMask" :wh="`60`" bg-s="contain" bg-r="no-repeat" pc="x" pt="0">
            <q-section v-if="prize.isSp" wh="100%" :bg-i="lightImg" class="bright"></q-section>
            <q-section :bg-i="prize.reward_icon" bg-s="contain" bg-r="no-repeat" bgP="center" wh="80%" pc="pc"></q-section>
          </q-section>
          <q-section wh="100% 33" fs="10" :fc="uiMeta?.config.nameColor" fw="400" pc="x" pt="62" class="text-center">
            {{ prize.reward_name }}
          </q-section>
        </q-section>
      </q-section>
      <!-- 一般是一些静态的文字 -->
      <slot></slot>
      <q-section
        :bg-i="uiMeta?.images?.rewardsConfirmButton"
        v-bind="uiMeta?.layout?.wrapper?.confirmButtonWrapper"
        @click="handleClose"></q-section>
    </q-section>
  </q-dialog>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'
const { $dialogs } = useDialogs()
// import { defaultConfig as uiMeta } from './use-rewards'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
})

const lightImg = 'https://cdn.hifunclub.com/opsite/gift/icon/light.png'
const prizeList = ref([])

// 内部方法：设置奖励列表
const openRewardsDialog = async rewards => {
  prizeList.value = rewards || []
  console.log(prizeList.value, 'prizeList.value')
}

// 保存原始的 open 方法
let originalOpen = null

onMounted(() => {
  // 等待 q-dialog 组件注册完成
  const tryOverride = () => {
    if ($dialogs.rewards && $dialogs.rewards.open && !originalOpen) {
      // 保存原始的 open 方法
      originalOpen = $dialogs.rewards.open.bind($dialogs.rewards)

      // 重写 open 方法
      $dialogs.rewards.open = async optionsOrRewards => {
        // 判断参数类型：如果是数组，则认为是直接传入的 rewards
        if (Array.isArray(optionsOrRewards)) {
          await openRewardsDialog(optionsOrRewards)
          // 延迟打开对话框，确保数据已更新
          setTimeout(() => {
            originalOpen()
          }, 500)
          return
        }

        // 如果是对象，检查是否有 rewards
        if (optionsOrRewards?.data?.rewards) {
          const rewards = optionsOrRewards.data.rewards
          // 移除 rewards，避免传递给原始 open
          const { rewards: _, ...restData } = optionsOrRewards.data
          await openRewardsDialog(rewards)
          // 延迟打开对话框，确保数据已更新
          setTimeout(() => {
            originalOpen({ ...optionsOrRewards, data: restData })
          }, 500)
          return
        }

        // 如果没有 rewards，直接调用原始方法
        return originalOpen(optionsOrRewards)
      }
    } else if (!$dialogs.rewards || !$dialogs.rewards.open) {
      // 如果还没注册，等待下一个 tick 再试
      nextTick(tryOverride)
    }
  }

  nextTick(tryOverride)
})

// const genClass = computed(() => {
//   const map = {
//     1: 'flex flex-row justify-center',
//     2: 'flex flex-row justify-around',
//     3: 'flex flex-row justify-around',
//   }
//   return map[prizeList.value.length]
// })

// const genScale = computed(() => {
//   const map = {
//     1: 'scale(1)',
//     2: 'scale(.9)',
//     3: 'scale(.8)',
//   }
//   return map[prizeList.value.length]
// })

const genClass = () => {
  const map = {
    1: 'flex flex-row justify-center',
    2: 'flex flex-row justify-around',
    3: 'flex flex-row justify-around',
  }
  return map[prizeList.value.length]
}

const genScale = () => {
  const map = {
    1: 'scale(1)',
    2: 'scale(.9)',
    3: 'scale(.8)',
  }
  return map[prizeList.value.length]
}

const handleClose = () => {
  $dialogs[props.uiMeta?.config?.rewardsName].close()
}

defineExpose({
  openRewardsDialog,
})
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-rows: repeat(3, 33.33%);
  overflow-y: auto;
  scrollbar-width: none;
  justify-items: center;
}

.bright {
  animation: bright 3s linear infinite;
  transform: translate3d(0, 0, 0);

  @keyframes bright {
    from {
      transform: rotate(0deg) scale(1.3);
    }

    to {
      transform: rotate(359deg) scale(1.3);
    }
  }
}
.text-center {
  text-align: center;
}
</style>
